import React from 'react';
import Select from 'react-select';
import { selectStyles, selectTheme } from './SelectStyles';
import './select-portal-styles.css';

export interface SelectOption {
  value: string;
  label: string;
}

interface SingleSelectProps {
  name: string;
  options: SelectOption[];
  placeholder: string;
  onChange: (selectedOption: any) => void;
  defaultValue?: SelectOption;
  value?: SelectOption | null;
  className?: string;
  width?: string;
}

const SingleSelect: React.FC<SingleSelectProps> = ({
  name,
  options,
  placeholder,
  onChange,
  defaultValue,
  value,
  className = "text-sm",
  width = "w-48"
}) => {
  return (
    <div className={`relative ${width} select-container shadow-sm
      [--select-bg:rgb(255,255,255)] 
      dark:[--select-bg:#1a2333] 
      [--select-text:rgb(17,24,39)] 
      dark:[--select-text:rgb(243,244,246)] 
      [--select-border:rgb(209,213,219)] 
      dark:[--select-border:rgb(75,85,99)] 
      [--select-hover:rgb(243,244,246)] 
      dark:[--select-hover:rgb(55,65,81)] 
      [--select-active:rgb(219,234,254)] 
      dark:[--select-active:rgb(55,65,81)] 
      [--select-multi-bg:rgb(219,234,254)] 
      dark:[--select-multi-bg:rgb(55,65,81)] 
      [--select-multi-text:rgb(30,58,138)] 
      dark:[--select-multi-text:rgb(243,244,246)] 
      [--select-placeholder:rgba(107,114,128,1)] 
      dark:[--select-placeholder:rgba(255,255,255,0.8)]`}>
      <Select
        name={name}
        options={options}
        className={`${className} select-component`}
        classNamePrefix="select"
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        value={value}
        styles={{
          ...selectStyles,
          container: (base) => ({
            ...base,
            width: '100%',
          }),
          control: (base, state) => ({
            ...selectStyles.control(base, state),
            minWidth: 'min-content',
          })
        }}
        theme={selectTheme}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default SingleSelect; 